import React from 'react';
import { Link } from 'react-router-dom';
import { useBestSellers } from '../../hooks/useBestSellers';
import BookGrid from '../../components/book/BookGrid';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const BestSellersPage = () => {
  const { books, loading } = useBestSellers();

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container" style={{ padding: '40px 20px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '40px' }}>
        Best Sellers
      </h1>

      {books.length === 0 ? (
        <p style={{ textAlign: 'center', fontSize: '1.2rem' }}>
          No best sellers listed yet.
        </p>
      ) : (
        <BookGrid books={books} />
      )}

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <Link to="/shop" className="button">
          Browse All Books
        </Link>
      </div>
    </div>
  );
};

export default BestSellersPage;